/**
 * Utility to get HubSpot tracking cookie only if user has consented to analytics
 * This ensures compliance with privacy regulations
 */

import { hasAnalyticsConsent } from './concordConsent';

export async function getHubSpotCookie(): Promise<string | null> {
  // Check if user has given consent for analytics cookies
  if (!hasAnalyticsConsent()) {
    console.log('HubSpot cookie not retrieved - user has not consented to analytics');
    return null;
  }

  // Check if cookie already exists (in case script was loaded previously with consent)
  const existingCookie = document.cookie
    .split('; ')
    .find(row => row.startsWith('hubspotutk='));
  
  if (existingCookie) {
    return existingCookie.split('=')[1];
  }

  // Check if HubSpot script is already loaded
  const existingScript = document.getElementById('hs-script-loader');
  if (existingScript) {
    // Script is loaded, wait for cookie
    return new Promise((resolve) => {
      let attempts = 0;
      const checkInterval = setInterval(() => {
        const cookie = document.cookie
          .split('; ')
          .find(row => row.startsWith('hubspotutk='));
        
        if (cookie || attempts > 30) { // 3 seconds timeout
          clearInterval(checkInterval);
          resolve(cookie ? cookie.split('=')[1] : null);
        }
        attempts++;
      }, 100);
    });
  }

  // If script isn't loaded and we have consent, we'll need to wait for
  // Concord to unblock it or load it dynamically
  console.log('HubSpot script not loaded yet, waiting for Concord to unblock it');
  
  // Wait for the script to be loaded by Concord
  return new Promise((resolve) => {
    let attempts = 0;
    const checkInterval = setInterval(() => {
      const cookie = document.cookie
        .split('; ')
        .find(row => row.startsWith('hubspotutk='));
      
      if (cookie) {
        clearInterval(checkInterval);
        resolve(cookie.split('=')[1]);
      } else if (attempts > 50) { // 5 seconds timeout
        clearInterval(checkInterval);
        console.log('Timeout waiting for HubSpot cookie');
        resolve(null);
      }
      attempts++;
    }, 100);
  });
} 